import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../../assets/logo.png";
import "./Navbar.css";

const FuturisticNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Scroll to hash when coming from another route
  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 300);
    }
  }, [location]);


  
  // Floating Orbs Background Component
  const FloatingOrbs = () => (
    <div className="orb-container">
      <div className="floating-orb orb-1"></div>
      <div className="floating-orb orb-2"></div>
      <div className="floating-orb orb-3"></div>
      <div className="grid-overlay"></div>
      <div className="scan-lines"></div>
    </div>
  );

  return (
    <div className="futuristic-navbar-wrapper">
      <FloatingOrbs />
      
      <Navbar
        expand="lg"
        fixed="top"
        className={`futuristic-navbar ${scrolled ? 'scrolled' : ''}`}
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
      >
        <Container fluid>
          {/* Logo Brand */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            <Navbar.Brand as={Link} to="/" className="navbar-brand-futuristic">
  <div className="logo-wrapper-futuristic">
    <img src={logo} alt="Naught Venture Logo" className="logo-img-futuristic" />
    <div className="logo-glow-futuristic"></div>
  </div>
</Navbar.Brand>

          </motion.div>

          {/* Navbar Toggle */}
          <Navbar.Toggle
            aria-controls="navbar-nav"
            className="navbar-toggle-futuristic"
            onClick={() => setExpanded(!expanded)}
          >
            <motion.div
              animate={expanded ? "open" : "closed"}
              variants={{
                open: { rotate: 180 },
                closed: { rotate: 0 }
              }}
              transition={{ duration: 0.3 }}
            >
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </motion.div>
          </Navbar.Toggle>

          {/* Navbar Links */}
          <Navbar.Collapse id="navbar-nav mx-auto">
            <Nav className="navbar-nav-futuristic">
              <NavItem 
                to="/" 
                label="Home" 
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setExpanded(false);
                }}
              />

              <NavItem 
                to="/about" 
                label="About Us" 
                onClick={() => setExpanded(false)}
              />

              <NavItem 
                as={HashLink}
                smooth
                to="/#services"
                label="Our Services" 
                onClick={() => setExpanded(false)}
              />

              <NavItem 
                to="/career" 
                label="Careers" 
                onClick={() => setExpanded(false)}
              />
              
              <NavItem 
                to="/contact" 
                label="Contact Us" 
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  setExpanded(false);
                }}
              />

              {/* Special CTA Button */}
              <motion.div
                className="nav-cta-container"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
               
              </motion.div>
            </Nav>
          </Navbar.Collapse>
        </Container>

        {/* Mobile Menu Backdrop */}
        <AnimatePresence>
          {expanded && (
            <motion.div
              className="mobile-menu-backdrop"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setExpanded(false)}
            />
          )}
        </AnimatePresence>
      </Navbar>
    </div>
  );
};

// Reusable NavItem Component
const NavItem = ({ to, label, onClick, as = Link, ...props }) => (
  <motion.div
    whileHover={{ y: -2 }}
    whileTap={{ y: 0 }}
    transition={{ type: "spring", stiffness: 400 }}
  >
    <Nav.Link
      as={as}
      to={to}
      className="nav-item-futuristic"
      onClick={onClick}
      {...props}
    >
      <span className="nav-text">{label}</span>
      <div className="nav-indicator"></div>
    </Nav.Link>
  </motion.div>
);

export default FuturisticNavbar;